import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';

import NotFoundPage from 'components/NotFoundPage';

import messages from './messages';

class ServiceRequestDetailData extends Component {
  static propTypes = {
    addPageToBreadcrumbs: PropTypes.func.isRequired,
    ChildComponent: PropTypes.func.isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: PropTypes.object.isRequired,
    i18n: PropTypes.shape({
      _: PropTypes.func.isRequired,
    }).isRequired,
    loadServiceRequest: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        serviceRequestId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    serviceRequestError: PropTypes.shape({
      error: PropTypes.oneOf([true]).isRequired,
    }),
    serviceRequestInfo: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    setCurrentServiceRequest: PropTypes.func.isRequired,
    setLoadingStarted: PropTypes.func.isRequired,
  }

  static defaultProps = {
    serviceRequestError: undefined,
  }

  componentWillMount() {
    const { match: { params: { serviceRequestId } } } = this.props;
    this.props.setCurrentServiceRequest(serviceRequestId);
  }

  componentDidMount() {
    const {
      addPageToBreadcrumbs,
      loadServiceRequest,
      location,
      match: { params: { serviceRequestId } },
      setLoadingStarted,
    } = this.props;

    addPageToBreadcrumbs({
      path: location.pathname,
      message: messages.breadcrumbs,
      number: serviceRequestId,
    });
    loadServiceRequest(serviceRequestId);
    setLoadingStarted();
  }

  componentWillReceiveProps(nextProps) {
    const {
      addPageToBreadcrumbs,
      loadServiceRequest,
      location,
      match: { params: { serviceRequestId } },
      setLoadingStarted,
    } = this.props;
    const nextServiceRequestId = nextProps.match.params.serviceRequestId;

    if (serviceRequestId !== nextServiceRequestId) {
      addPageToBreadcrumbs({
        path: location.pathname,
        message: messages.breadcrumbs,
        number: nextServiceRequestId,
      });
      loadServiceRequest(nextServiceRequestId);
      setLoadingStarted();
    }
  }

  componentWillUnmount() {
    this.props.setCurrentServiceRequest();
  }

  render() {
    const {
      ChildComponent,
      i18n,
      serviceRequestError,
    } = this.props;

    if (serviceRequestError) {
      return <NotFoundPage />;
    }

    return (
      <div>
        <Helmet
          title={i18n._(messages.title)}
          meta={[{ name: 'description', content: i18n._(messages.description) }]}
        />
        <ChildComponent {...this.props.componentProps} />
      </div>
    );
  }
}

export default ServiceRequestDetailData;



// WEBPACK FOOTER //
// ./containers/ServiceRequestDetailData/Component.js